import { SET_PUSH_DISPLAYED, SET_PUSH_ACCEPTATION } from './push.actionTypes'

export const setPushDisplayed =
  (timestamp = Date.now()) =>
  dispatch =>
    dispatch({ type: SET_PUSH_DISPLAYED, payload: { timestamp } })

export const setPushAcceptation = () => dispatch => dispatch({ type: SET_PUSH_ACCEPTATION })
